import React, { useEffect, useRef, useState } from "react";
import { generateQRCode } from "../../../../utils/qr";
import {Divider, Typography} from "@material-ui/core";

export const QRCode = ({ code }) => {
    const [debouncedText, setDebouncedText] = useState('');
    const canvasRef = useRef(null);
    const timerRef = useRef(null);

    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            setDebouncedText(code.label);
          }, 1500);
        return () => {
        clearTimeout(timerRef.current);
        }
    }, [code])
    
    useEffect(() => {
        if (debouncedText) {
            generateQRCode(canvasRef, code.label)
        }
    }, [debouncedText])
    
    return (
        <React.Fragment>
            <Divider style={{width: '100%'}} />
            {code.displayName && <Typography>{code.displayName}</Typography>}
            {code.label && <canvas style={{display: 'block'}} ref={canvasRef}></canvas>}
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/ManageReceipt/QRCode.js